import { twdClass } from "../../../constants/tailwind.constants";
import { Button, BtnStyle, BtnBack, BtnAdd, BtnNext} from "../../ui/com_ui";


export const RspHeader = ({
  onBack=()=>{},
  onStyle=()=>{},
  title,
}) => {
  return (
    <div className={twdClass("pt-3 pb-3 flex items-center")}>
      <BtnBack
        className={"mr-4"}
        onClick={onBack}
      >              
      </BtnBack>
      <div className={twdClass("flex-grow")}>
        <div className={twdClass("text-gray-800 text-sm font-semibold")}>
          {title}
        </div>
      </div>
      <BtnStyle              
        onClick={onStyle}
      > 
      </BtnStyle>            
    </div>
  );
};
